import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAdmin } from "./AdminContext";
import { Logo } from "@/components/site/Logo";
import { Lock, Mail, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAdmin();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data.token, data.admin);
      navigate("/adc/dashboard");
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1f222d] px-4 relative overflow-hidden">
      <div className="glow-orb w-[400px] h-[400px] bg-[#d8b4fe] -top-32 -right-20 animate-pulse-glow" />
      <div className="glow-orb w-[350px] h-[350px] bg-indigo-500 bottom-0 -left-20 animate-pulse-glow" />
      <form onSubmit={submit} className="card-surface p-8 w-full max-w-md relative" data-testid="admin-login-form">
        <div className="flex justify-center mb-6"><Logo className="h-10" /></div>
        <h1 className="text-2xl font-extrabold text-white text-center">Yönetici Girişi</h1>
        <p className="text-gray-400 text-sm text-center mt-1 mb-6">TakipciSatis Yönetim Paneli</p>
        {err && <div className="bg-red-500/15 text-red-400 text-sm rounded-lg px-4 py-3 mb-4" data-testid="login-error">{err}</div>}
        <div className="space-y-4">
          <div className="flex items-center gap-2 bg-[#171922] border border-white/10 rounded-xl px-4">
            <Mail size={18} className="text-gray-400" />
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="E-posta"
              className="flex-1 bg-transparent py-3.5 text-white outline-none" data-testid="login-email" required />
          </div>
          <div className="flex items-center gap-2 bg-[#171922] border border-white/10 rounded-xl px-4">
            <Lock size={18} className="text-gray-400" />
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Şifre"
              className="flex-1 bg-transparent py-3.5 text-white outline-none" data-testid="login-password" required />
          </div>
        </div>
        <button type="submit" disabled={loading} className="btn-gradient w-full py-3.5 rounded-xl font-bold mt-6 flex items-center justify-center gap-2" data-testid="login-submit">
          {loading ? <Loader2 size={18} className="animate-spin" /> : "Giriş Yap"}
        </button>
      </form>
    </div>
  );
}
